import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route, Redirect } from 'react-router-dom'
import * as routerPath from './LB/constants/routePaths'
import api from "./LB/api/api";
class AuthRouter extends Component {
    render() {  
        const { component: Component, ...rest } = this.props
        const isLogged = api.getUserToken() === null ? false : true;
      
        return (
            <Route {...rest} render={props => {
              return isLogged
                  ? <Component {...props} />
                  : <Redirect to={routerPath.INDEX} />
            }} />
        )
      }
}

export default withRouter(AuthRouter); 